import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noOption: {
		id: 'issue-table-grouping.group-row.group-header.option-group-header.no-option-non-final',
		defaultMessage: 'No value',
		description: 'Label for grouped items without option value',
	},
});
